import { formatMoney } from '../../utils/FormatUtils';

export const SERVICE_COLUMNS = [
	{
		title: 'Tên Dịch Vụ',
		field: 'name',
	},
	{
		title: 'Đơn Vị',
		field: 'termUnitName',
		className: 'w-80px text-center',
		render: (rowData: any) => {
			return <div className="text-center">{rowData?.termUnitName}</div>;
		},
	},
	{
		title: 'Đối Tượng',
		field: 'objectTypeName',
		className: 'w-100px text-center',
		render: (rowData: any) => {
			return <div className="text-center">{rowData?.objectTypeName}</div>;
		},
	},
	{
		title: 'SL',
		field: 'oqty',
		className: 'w-50px text-center',
		render: (rowData: any) => {
			return <div className="text-center">{rowData?.oqty}</div>;
		},
	},
	{
		title: 'Đơn Giá',
		field: 'svcPrice',
		className: 'w-100px text-center',
		render: (rowData: any) => {
			return <div className="text-end">{formatMoney(rowData?.svcPrice)}</div>;
		},
	},
	{
		title: '% BHYT',
		field: 'paymentInsPercent',
		className: 'w-80px text-center',
		render: (rowData: any) => {
			return <div className="text-center">{rowData?.paymentInsPercent}</div>;
		},
	},
	{
		title: 'Thành Tiền',
		field: 'svcTotal',
		className: 'w-100px text-center',
		render: (rowData: any) => {
			return <div className="text-end">{formatMoney(rowData?.svcTotal)}</div>;
		},
	},
	{
		title: 'BHYT Trả',
		field: 'paymentInsTotal',
		className: 'w-100px text-center',
		render: (rowData: any) => {
			return <div className="text-end">{formatMoney(rowData?.paymentInsTotal)}</div>;
		},
	},
	{
		title: 'BN Trả',
		field: 'paymentPtTotal',
		className: 'w-100px text-center',
		render: (rowData: any) => {
			return <div className="text-end">{formatMoney(rowData?.paymentPtTotal)}</div>;
		},
	},
];
